import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import imgFallback from 'src/utils/image';
import { classNames } from 'src/utils/helpers';

function SectionHeader({ title, tagline, image, description, isDark, textAlign, children }) {
  return (
    <Container fluid className={textAlign}>
      <Row noGutters style={{ maxWidth: 650 }} className="mx-auto">
        {tagline && (
          <Col
            xs={12}
            className={classNames('text-uppercase', {
              'text-white': isDark,
            })}
          >
            {tagline}
          </Col>
        )}
        {title && (
          <Col
            xs={12}
            as="h2"
            className={classNames('mt-2', {
              'text-white': isDark,
            })}
          >
            {title}
          </Col>
        )}
        {description && (
          <Col
            xs={12}
            as="p"
            className={classNames('mt-2', {
              'text-gray-500': isDark,
              'text-muted': !isDark,
            })}
          >
            {description}
          </Col>
        )}
        {image && (
          <Col xs={12} className="px-0 py-2">
            <GatsbyImage id={image?._key} image={image?.image?.asset?.gatsbyImageData ?? imgFallback} alt={image?.alt ?? ''} />
          </Col>
        )}
        {children && (
          <Col xs={12} className="mt-5">
            {children}
          </Col>
        )}
      </Row>
    </Container>
  );
}

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  tagline: PropTypes.string,
  image: PropTypes.shape({}),
  description: PropTypes.string,
  isDark: PropTypes.bool,
  textAlign: PropTypes.string,
  children: PropTypes.node,
};

SectionHeader.defaultProps = {
  tagline: '',
  image: null,
  description: '',
  isDark: false,
  textAlign: 'text-center',
  children: null,
};

export default SectionHeader;
